
import Vue from 'vue';

export default Vue.extend({
	name: 'ComplexBackgroundBig',
	props: {
		includeLeftBlobs: { type: Boolean, default: false },
	},
	data () {
		return {};
	},
});
